/**** Vanilla Javascript Apps ****/
import initAccordion from "./components/Accordion/initAccordion.js";
import initAccordionGroup from "./components/Accordion/initAccordionGroup.js";
import initAccordionCategories from "./components/Accordion/initAccordionCategories.js";
import initAlertBanner from "./components/AlertBanner/initAlertBanner.js";
import initAssetsCard from "./components/AssetsCard/initAssetsCard.js";
import initAudioPlayer from "./components/AudioPlayer/initAudioPlayer.js";
import initBackgroundVideo from "./components/BackgroundVideo/initBackgroundVideo.js";
import initBreadcrumb from "./components/Breadcrumb/initBreadcrumb.js";
import initLanguageSelector from "./components/LanguageSelector/initLanguageSelector.js";
import initManualInternalPromoSlider from "./components/ManualInternalPromoSlider/initManualInternalPromoSlider.js";
import initNavMenu from "./components/NavMenu/initNavMenu.js";
import initPrivacyBanner from "./components/PrivacyBanner/initPrivacyBanner.js";
import initReadMore from "./components/ReadMore/initReadMore.js";
import initScrollingEmbed from "./components/ScrollingEmbed/initScrollingEmbed.js";
import initSearchBox from "./components/SearchBox/initSearchBox.js";
import initSecondaryNav from "./components/SecondaryNav/initSecondaryNav.js";
import initSimpleContentListing from "./components/SimpleContentListing/initSimpleContentListing.js";
import initSimpleHomepageHero from "./components/SimpleHomepageHero/initSimpleHomepageHero.js";
import initTabbedContent from "./components/TabbedContent/initTabbedContent.js";
import initTextCards from "./components/TextCards/initTextCards.js";
import initFramework from "./components/Framework/initFramework.js";
import initScrollingTilesFullWidth from "./components/ScrollingTilesFullWidth/initScrollingTilesFullWidth.js";
import initArticleMetadata from "./components/ArticleMetadata/initArticleMetadata.js";
import initScrollSnapping from "./components/Container/initScrollSnapping.js";

// This is required to make Storybook run JS when patterns are choosen
document.addEventListener("DOMContentLoaded", () => {
  initAccordionGroup();
  initAccordion();
  initAccordionCategories();
  initAlertBanner();
  initArticleMetadata();
  initAssetsCard();
  initAudioPlayer();
  initBackgroundVideo();
  initBreadcrumb();
  initFramework();
  initLanguageSelector();
  initManualInternalPromoSlider();
  initNavMenu();
  initPrivacyBanner();
  initReadMore();
  initScrollingEmbed();
  initScrollingTilesFullWidth();
  initSearchBox();
  initSecondaryNav();
  initSimpleContentListing();
  initSimpleHomepageHero();
  initTabbedContent();
  initTextCards();
  initScrollSnapping();
});
